module.exports = __webpack_public_path__ + "static/integration/img/ally-icon-indicator-medium-learnUltra.8f18c65040f94840495229a08f67ee03.svg";